import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import useCompaniesContext from '../hooks/useCompaniesContext';

interface CompanyTextProps extends Omit<TextProps, 'styles'> {
  companyId: string;
  shortName?: boolean;
  addLineBreak?: boolean;
  style?: React.CSSProperties & { [key: string]: any };
}

export const CompanyText: React.FC<CompanyTextProps> = (props) => {
  const { companyId, shortName, addLineBreak, ...rest } = props;

  const { getCompanyById } = useCompaniesContext();

  const company = useMemo(() => {
    return getCompanyById(companyId);
  }, [companyId, getCompanyById]);

  if (!company) return null;

  return (
    <Typography.Text {...rest}>
      {shortName ? company.shortName : company.fullName}
      {addLineBreak && <br />}
    </Typography.Text>
  );
};

export default CompanyText;
